import React, {useEffect, useState, useRef} from 'react';
import {AdvancedMarker, InfoWindow, Pin, useMap } from '@vis.gl/react-google-maps';
import {MarkerClusterer} from '@googlemaps/markerclusterer';
import CustomeInfoWindow from './CustomeInfoWindow'

const SingleAdvancedMarker = ({ points, closeInfo, handleInfoClose, openPoint, isClustered }) => {
    const map = useMap();
    const [markers, setMarkers] = useState({});
    const [selectedMarker, setSelectedMarker] = useState([])
    const clusterer = useRef(null);
    const [infoWindowOpen, setInfoWindowOpen] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState("Copy Coordinate")

    const showInfoWindow = (pointKey) => {
        setCopyButtonText("Copy Coordinate")
        setSelectedMarker(pointKey)
        handleInfoClose()
        setInfoWindowOpen(true);
      };

    const hideInfoWindow = () => {
        setInfoWindowOpen(false);
    };

    useEffect(() => {
      if (!map) return;
      if(!isClustered) return;
      if (!clusterer.current) {
        clusterer.current = new MarkerClusterer({map});
      }
    }, [map]);
  
    useEffect(() => {
      clusterer.current?.clearMarkers();
      clusterer.current?.addMarkers(Object.values(markers));
    }, [markers]);

    useEffect(() => {
        return () => {
            clusterer.current?.clearMarkers();
        }
      }, []);

      useEffect(() => {
        clusterer.current?.clearMarkers();
      }, [points]);

      useEffect(() => {
        if(openPoint) {
          showInfoWindow(openPoint.key)
        }
      }, [openPoint]);

      useEffect(() => {
        if(closeInfo) {
          setInfoWindowOpen(false)
          handleInfoClose()
        }
      }, [closeInfo]);
  

    const setMarkerRef = (marker, key) => {
      if (marker && markers[key]) return;
      if (!marker && !markers[key]) return;
  
      setMarkers(prev => {
        if (marker) {
          return {...prev, [key]: marker};
        } else {
          const newMarkers = {...prev};
          delete newMarkers[key];
          return newMarkers;
        }
      });
    };

    const copyToClipboard = (point) => {
      navigator.clipboard.writeText(`${point.lat}, ${point.lng}`)
      setCopyButtonText("Copied!")
    }
  
    return (
        <>
          {points.map(point => (
            <>  
                <AdvancedMarker 
                    position={point}
                    clickable={true}
                    onClick={() => showInfoWindow(point.key)}
                    key={point.key}
                    ref={marker => setMarkerRef(marker, point.key)}>
                        <Pin
                            background={point.color}
                            borderColor={'#000000'}
                            glyphColor={'#FFFFFF'}
                        />
                </AdvancedMarker>
                
                {infoWindowOpen && selectedMarker.includes(point.key) && (
                    <CustomeInfoWindow point={point} hideInfoWindow={hideInfoWindow} copyButtonText={copyButtonText} copyToClipboard={copyToClipboard} />
                )}
            </>
          ))}
        </>
      );
  };

export default SingleAdvancedMarker